/**
 * @param {array} vehicles
 * @returns {object}
 */
export const getVehiclesFilter = (vehicles) => {
  if (!vehicles) return {};

  return (vehicles || []).reduce((acc, current) => {
    return { suitable_vehicle_type: [...(acc.suitable_vehicle_type || []), current.value] };
  }, {});
};

export default getVehiclesFilter;
